import React from 'react'
import { useSelector } from 'react-redux'

import { usernameSelector, shouldSeeWelcomeSelector } from 'selectors/users'
import { useNavigateOnClick } from 'effects/useRoutes'


const HeaderNavigation = () => {
  const username = useSelector(usernameSelector),
        shouldSeeWelcome = useSelector(shouldSeeWelcomeSelector)

  if (!username) { return }

  // hide navigation links when user should see welcome page
  if (shouldSeeWelcome) { return null }

  return (
    <ul className="main-nav-links">
      <li><HeaderNavButton text="Devices" /></li>
      <li><HeaderNavButton text="Feeds" /></li>
      <li><HeaderNavButton text="Dashboards" /></li>
      <li><HeaderNavButton text="Actions" /></li>
      <li><HeaderNavButton text="Power-Ups" route="services" /></li>
    </ul>
  )
}

export default HeaderNavigation

const HeaderNavButton = ({ title, text, route }) => {
  if(!text) { throw new Error("text prop required for HeaderNavButton") }

  const navigate = useNavigateOnClick()

  route = route || text.toLowerCase()

  return (
    <button onClick={navigate(route)} title={ title || text }>
      { text }
    </button>
  )
}
